export function RetryOnError(callback:Function, retryWaitMs:number) {
    try {
        callback();
    }
    catch {
        setTimeout(() => {
            RetryOnError(callback, retryWaitMs);
        }, retryWaitMs)
    }
}

export async function RetryOnPromiseError(promise:Promise<any>, retryWaitMs:number) {
    try {
        await promise;
    }
    catch {
        setTimeout(() => {
            RetryOnPromiseError(promise, retryWaitMs);
        }, retryWaitMs)
    }   
}